import { render, staticRenderFns } from "./RequestAccountStatment.vue?vue&type=template&id=01f6ff3e&scoped=true&"
import script from "./RequestAccountStatment.vue?vue&type=script&lang=js&"
export * from "./RequestAccountStatment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f6ff3e",
  null
  
)

export default component.exports